import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';
import detailsPolyfill from "details-element-polyfill"

objectFitImages();
objectFitVideos();


import './helpers/cookies.js';
import './components/polyfills.js';
import './components/lazy.js';
import './components/nav.js';
import './components/popup.js';
import './components/filter.js';
import './components/cards.js';
import './components/show-more.js';
import './components/dropdown.js';
import './components/carousel.js';
import './components/mobilenav.js';
//import './components/infinitescroll.js';
import './components/sticky-cta.js';
import './components/header.js';
import './components/help.js';
import './components/intro.js';
import './components/sidemenu.js';
import './components/variants.js';
import './components/transUpper.js';
import './components/ajax-products.js';
import './components/ajax-modals.js';
import './components/video.js';
import './components/modals.js';
import './components/getposition.js';
import './components/revealMore.js';
import './components/tabs.js';
import './components/animated-plus';
import './components/details';
import './components/tables';


// WEBPACK FOOTER //
// ./scripts/index.js